import { BrowserRouter } from 'react-router-dom'

import { DocumentBranding } from '@/components/brand/DocumentBranding'
import { AppRoutes } from '@/routes/AppRoutes'
import { ThemeColorProvider } from '@/components/ThemeColorProvider'

function App() {
  return (
    <BrowserRouter>
      <ThemeColorProvider>
        <DocumentBranding />
        <AppRoutes />
      </ThemeColorProvider>
    </BrowserRouter>
  )
}

export default App
